import { render, staticRenderFns } from "./VideoHome.vue?vue&type=template&id=0347a600&scoped=true"
import script from "./VideoHome.vue?vue&type=script&lang=js"
export * from "./VideoHome.vue?vue&type=script&lang=js"
import style0 from "./VideoHome.vue?vue&type=style&index=0&id=0347a600&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0347a600",
  null
  
)

export default component.exports